// src/supabaseClient.js
import { createClient } from '@supabase/supabase-js';

const supabaseUrl = process.env.REACT_APP_SUPABASE_URL; // Supabase URL
const supabaseAnonKey = process.env.REACT_APP_SUPABASE_ANON_KEY; // Supabase anon key

export const supabase = createClient(supabaseUrl, supabaseAnonKey)
